import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';

/**
 * Multi-page A4 PDF by slicing the canvas (sharp text, no squashing).
 * @param {HTMLElement} element
 * @param {string} filename
 */
export async function downloadPdfFromElement(element, filename) {
  const canvas = await html2canvas(element, {
    scale: 2,
    useCORS: true,
    allowTaint: true,
    backgroundColor: '#ffffff',
    logging: false,
  });

  const pdf = new jsPDF({ unit: 'mm', format: 'a4', orientation: 'portrait' });
  const pageWidth = pdf.internal.pageSize.getWidth();
  const pageHeight = pdf.internal.pageSize.getHeight();
  const margin = 8;
  const usableWidth = pageWidth - margin * 2;
  const usableHeight = pageHeight - margin * 2;

  const mmPerPx = usableWidth / canvas.width;
  let yPx = 0;

  while (yPx < canvas.height) {
    const slicePx = Math.min(
      Math.ceil(usableHeight / mmPerPx),
      canvas.height - yPx
    );
    if (slicePx < 1) break;

    const sliceCanvas = document.createElement('canvas');
    sliceCanvas.width = canvas.width;
    sliceCanvas.height = slicePx;
    sliceCanvas.getContext('2d').drawImage(
      canvas,
      0,
      yPx,
      canvas.width,
      slicePx,
      0,
      0,
      canvas.width,
      slicePx
    );

    const sliceData = sliceCanvas.toDataURL('image/png');
    const sliceMmH = slicePx * mmPerPx;

    if (yPx > 0) {
      pdf.addPage();
    }
    pdf.addImage(sliceData, 'PNG', margin, margin, usableWidth, sliceMmH);
    yPx += slicePx;
  }

  pdf.save(filename);
}
